var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFragen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64.53 64.53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-question-circle",
    className: "cls-1",
    d: "M64.53,32.26c0,17.82-14.44,32.27-32.26,32.27C14.45,64.53,0,50.09,0,32.27,0,14.45,14.44,0,32.27,0c0,0,0,0,0,0,17.82,0,32.26,14.44,32.27,32.26h0ZM33.13,10.66c-7.09,0-11.61,2.99-15.16,8.3-.46,.69-.31,1.61,.35,2.11l4.52,3.42c.68,.51,1.64,.39,2.17-.28,2.32-2.95,3.92-4.66,7.45-4.66,2.66,0,5.94,1.71,5.94,4.29,0,1.95-1.61,2.95-4.23,4.42-3.06,1.72-7.11,3.85-7.11,9.19v.52c0,.86,.7,1.56,1.56,1.56h7.29c.86,0,1.56-.7,1.56-1.56h0v-.17c0-3.7,10.82-3.86,10.82-13.88,0-7.55-7.83-13.27-15.16-13.27h0Zm-.87,32.27c-3.31,0-5.98,2.68-5.98,5.99s2.68,5.99,5.98,5.99,5.99-2.68,5.99-5.99c0-3.3-2.68-5.98-5.99-5.99Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFragen);
export default __webpack_public_path__ + "static/media/Fragen.5c4186866adefc65928585f0814b0571.svg";
export { ForwardRef as ReactComponent };